import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from 'material-ui/styles';
import { FormControlLabel } from "material-ui/Form";
import Radio, { RadioGroup } from "material-ui/Radio";

const styles = () => ({
  group: {
    flexDirection: "row",
  },

  formControlLabel: {
    fontSize: "12px",
    color: "rgb(113, 115, 123)",
  },
});

class AndOrSearchControl extends React.Component {
  // 複数のキーワード検索の種類があるので、それぞれに対応できるように抽象度を高めに記載しています。
  render() {
    const { classes, isExclude, typeKey, disabled } = this.props;

    // "exe_feature"等の文字列が入り、"is_and_search_exe_feature_exclude_keyword"等になる
    const type = "is_and_search_" + typeKey + (isExclude ? "_exclude_" : "_") + "keyword";

    return (
      <div style={this.props.style}>
        <RadioGroup
          className={classes.group}
          value={this.props.isAndSearch ? "and" : "or"}
          onChange={(e) => this.props.handleRadioChange(e, type)}
        >
          <FormControlLabel
            value="and"
            control={<Radio color="primary" />}
            label="AND検索"
            classes={{ label: classes.formControlLabel }}
            disabled={disabled}
          />
          <FormControlLabel
            value="or"
            control={<Radio color="primary" />}
            label="OR検索"
            classes={{ label: classes.formControlLabel }}
            disabled={disabled}
          />
        </RadioGroup>
      </div>
    )
  }
}

AndOrSearchControl.propTypes = {
  classes: PropTypes.object.isRequired,
  style: PropTypes.object,
  isExclude: PropTypes.bool,
  disabled: PropTypes.bool,
  typeKey: PropTypes.string.isRequired,
  isAndSearch: PropTypes.bool.isRequired,
  handleRadioChange: PropTypes.func.isRequired,
};

AndOrSearchControl.defaultProps = {
  isExclude: false,
}

export default withStyles(styles)(AndOrSearchControl);



// WEBPACK FOOTER //
// ./src/components/ExecutiveList/controls/AndOrSearchControl.jsx